import Vue from 'vue';
import VueI18n from 'vue-i18n';
import elementUILocale from 'element-ui/lib/locale';
import store from '@/modules/store';

Vue.use(VueI18n);

// Translations
import en from './translations/en.js';
import de from './translations/de.js';
import fr from './translations/fr.js';

export const translations = [
  { code: 'en', name: 'English', translation: en },
  { code: 'de', name: 'Deutsch', translation: de },
  { code: 'fr', name: 'Français', translation: fr }
];

// Sets the locale
export function setLocale(locale) {
  const isValid = translations.filter(l => l.code === locale).length > 0;
  if (isValid) {
    i18n.locale = locale;
    store.commit('setLocale', locale);
    elementUILocale.use(config.messages[locale]);
  }
}

// i18n config
const config = {
  fallbackLocale: 'en',
  dateTimeFormats: {},
  numberFormats: {},
  messages: {}
};

// Merge translations into a single config
translations.map(t => {
  config.dateTimeFormats[t.code] = t.translation.dateTimeFormats;
  config.numberFormats[t.code] = t.translation.numberFormats;
  config.messages[t.code] = t.translation.messages;
});

const i18n = new VueI18n(config);
export default i18n;

// Set the initial locale
setLocale(store.state.locale || 'en');
